export default {
  entwurf: '184A9DA468C',
  final: '184A9DA468E',
};
